import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { FaLayerGroup } from 'react-icons/fa';
import Switch from '../../components/Switch/Switch';
import Loader from '../../components/Loader/Loader';
import './ProgramSessionMappingForm.css';

const ProgramSessionMappingForm = ({ onSubmit, programList, onInputChange, onSwitchChange, programIds, loader }) => {
  return (
    <Form onSubmit={onSubmit}>
      {loader && <div className="loader"><Loader /></div>}
      <div className="row">
        <div className="col-md-12">
          <Form.Label className="d-flex align-items-center gap-2">
            <FaLayerGroup />
            <span>Available for classes</span>
          </Form.Label>
          <div className="psm-panel">
            <div className="psm-select-all-row">
              <Switch
                label='Select All'
                value={'1'}
                checked={programIds.length === programList.length}
                name='all'
                id='select-all'
                onChange={onSwitchChange}
              />
              <span className="small text-muted">{programIds.length} of {programList.length} selected</span>
            </div>
            <div className="psm-class-grid">
              {programList && programList.map((program, idx) => (
                <div className="psm-class-item" key={idx}>
                  <Switch
                    label={program.name}
                    id={program.id}
                    name="programIds"
                    value={program.id}
                    checked={programIds.includes(program.id.toString())}
                    onChange={onInputChange}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-12 justify-content-end d-flex">
          <div className="mt-3">
            <Button
              variant="success"
              disabled={loader}
              type="submit">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default ProgramSessionMappingForm;
